"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getfullMonthAndYear = void 0;
const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];
const days = [
    'um',
    'dois',
    'três',
    'quatro',
    'cinco',
    'seis',
    'sete',
    'oito',
    'nove',
    'dez',
    'onze',
    'doze',
    'treze',
    'quatorze',
    'quinze',
    'dezesseis',
    'dezessete',
    'dezoito',
    'dezenove',
    'vinte',
    'vinte e um',
    'vinte e dois',
    'vinte e três',
    'vinte e quatro',
    'vinte e cinco',
    'vinte e seis',
    'vinte e sete',
    'vinte e oito',
    'vinte e nove',
    'trinta',
    'trinta e um',
];
const getfullMonthAndYear = (date) => {
    if (date == null)
        return '';
    const dateArray = date.split('/');
    const index = 1;
    const day = parseInt(dateArray[0]);
    const month = parseInt(dateArray[1]);
    return `${days[day - index]} de ${months[month - index]}`;
};
exports.getfullMonthAndYear = getfullMonthAndYear;
